import React, { useContext, useState, useEffect } from "react";
import { CrackersContext } from "../CrackersContext";

export function useCrackersFilters() {
  const { crackersFilter, setCrackersFilter } = useContext(CrackersContext);
  const [filters, setFilters] = useState(crackersFilter || []);
  const [loading, setLoading] = useState(!crackersFilter.length);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (crackersFilter.length > 0) {
      setLoading(false);
      return;
    }

    async function fetchFilters() {
      try {
        const response = await fetch("/v1/crackers/filters");
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setFilters(data);
        setCrackersFilter(data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    }

    fetchFilters();
  }, [crackersFilter, setCrackersFilter]);

  return { filters, loading, error };
}
